/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class JwtApiBase {
  AccessToken: Promise<string> | undefined

  protected readonly transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    const token = await this.AccessToken

    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    }

    return options
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public readonly setAccessToken = (token: Promise<string>) => {
    this.AccessToken = token
  }
}

export interface ILearningManagementClientV1 {

    /**
     * Check service availability.
     * @return Service is alive
     */
    ping(): Promise<void>;

    /**
     * Get a list of all plugins.
     * @return List of all available plugins.
     */
    getAllPlugins(): Promise<string[]>;

    /**
     * Get a list of all default templates.
     * @return List of all default templates.
     */
    getAllDefaultTemplates(): Promise<DefaultTemplate[]>;

    /**
     * Create Default Template
     * @return Default Template successfully created and can be found in the body of the response.
     */
    createDefaultTemplate(body: DefaultTemplateWithoutId): Promise<DefaultTemplate>;

    /**
     * Delete Default Template
     * @param defaultTemplateId DefaultTemplateId to retrieve
     * @return Default Template deleted.
     */
    deleteDefaultTemplateById(defaultTemplateId: string): Promise<void>;

    /**
     * Get Default Template
     * @param defaultTemplateId DefaultTemplateId to retrieve
     * @return Default Template
     */
    getDefaultTemplateById(defaultTemplateId: string): Promise<DefaultTemplate>;

    /**
     * Update Default Template
     * @param defaultTemplateId DefaultTemplateId to update
     * @return Default Template successfully updated and can be found in the body of the response.
     */
    updateDefaultTemplate(defaultTemplateId: string, body: DefaultTemplateWithoutId): Promise<DefaultTemplate>;

    /**
     * Get a list of all implementations.
     * @return List of all Implementations.
     */
    getAllImplementations(pageNumber: number, pageSize: number): Promise<Implementation[]>;

    /**
     * Create Implementation
     * @return Implementation successfully created and can be found in the body of the response.
     */
    createImplementation(body: ImplementationWithoutId): Promise<Implementation>;

    /**
     * Delete Implementation
     * @param implementationId ImplementationId to retrieve
     * @return Implementation deleted.
     */
    deleteImplementationById(implementationId: string): Promise<void>;

    /**
     * Get Implementation
     * @param implementationId ImplementationId to retrieve
     * @return Implementation
     */
    getImplementationById(implementationId: string): Promise<Implementation>;

    /**
     * Update Implementation
     * @param implementationId ImplementationId to retrieve
     * @return Implementation successfully updated and can be found in the body of the response.
     */
    updateImplementation(implementationId: string, body: ImplementationWithoutId): Promise<Implementation>;

    /**
     * Get a list of all Event Templates
     * @param implementationId (optional) 
     * @return List of all matching Event Templates
     */
    getAllEventTemplates(implementationId: string | undefined, pageNumber: number, pageSize: number): Promise<EventTemplate[]>;

    /**
     * Create Event Template
     * @return Event Template successfully created and can be found in the body of the response.
     */
    createEventTemplate(body: EventTemplateWithoutId): Promise<EventTemplate>;

    /**
     * @param eventTemplateId EventTemplate to delete.
     * @return EventTemplate deleted.
     */
    deleteEventTemplateById(eventTemplateId: string): Promise<void>;

    /**
     * @param eventTemplateId EventTemplate to retrieve.
     * @return EventTemplate
     */
    getEventTemplateById(eventTemplateId: string): Promise<EventTemplate>;

    /**
     * Update Event Template
     * @param eventTemplateId EventTemplate to retrieve.
     * @return Event Template successfully updated and can be found in the body of the response.
     */
    updateEventTemplate(eventTemplateId: string, body: EventTemplateWithoutId): Promise<EventTemplate>;

    /**
     * Get a list of all Learning Events
     * @param contentMetadataId (optional) 
     * @return List of all matching Events
     */
    getAllLearningEvents(contentMetadataId: string | undefined, pageNumber: number, pageSize: number): Promise<LearningEvent[]>;

    /**
     * Create Learning Event
     * @return Learning Event successfully created and can be found in the body of the response.
     */
    createLearningEvent(body: LearningEventWithoutId): Promise<LearningEvent>;

    /**
     * Delete LearningEvent
     * @param learningEventId LearningEventId to retrieve
     * @return LearningEvent deleted.
     */
    deleteLearningEventById(learningEventId: string): Promise<void>;

    /**
     * Get LearningEvent
     * @param learningEventId LearningEventId to retrieve
     * @return LearningEvent
     */
    getLearningEventById(learningEventId: string): Promise<LearningEvent>;

    /**
     * Update LearningEvent
     * @param learningEventId LearningEventId to retrieve
     * @return LearningEvent successfully updated and can be found in the body of the response.
     */
    updateLearningEvent(learningEventId: string, body: LearningEventWithoutId): Promise<LearningEvent>;

    /**
     * Get a list of all Learning progress
     * @param contentMetadataId (optional) Content Metadata Id to which the progress belongs.
     * @param companyId (optional) Company Id to which the progress belongs.
     * @param userId (optional) User Id to which the progress belongs.
     * @return Learning Progress
     */
    getAllLearningProgress(contentMetadataId: string | undefined, companyId: string | undefined, userId: string | undefined, pageNumber: number, pageSize: number): Promise<LearningProgress[]>;

    /**
     * Submit a rating for an experience.
     * @param roomMetadataId RoomMetadataId to submit rating for.
     * @return Rating successfully submitted.
     */
    submitRating(roomMetadataId: string, body: Rating): Promise<void>;

    /**
     * Get TinCan SCORM Package.
     * @param roomMetadataId RoomMetadataId to retrieve SCORM package for.
     * @return The tincan configuration
     */
    getTinCanScormPackage(roomMetadataId: string): Promise<FileResponse>;

    /**
     * Get rating metrics for company experiences.
     * @param companyId CompanyId to retrieve rating metrics for.
     * @return List of rating metrics for the company.
     */
    getCompanyRatings(companyId: string, body: MetricFilter): Promise<RatingMetricResult>;

    /**
     * Get external rating metrics for company experiences.
     * @param companyId CompanyId to retrieve rating metrics for.
     * @return List of rating metrics for the company.
     */
    getExternalCompanyRatings(companyId: string, body: ExternalMetricFilter): Promise<ExternalRatingMetricResult>;
}

export class LearningManagementClientV1 extends JwtApiBase implements ILearningManagementClientV1 {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Check service availability.
     * @return Service is alive
     */
    ping(): Promise<void> {
        let url_ = this.baseUrl + "/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get a list of all plugins.
     * @return List of all available plugins.
     */
    getAllPlugins(): Promise<string[]> {
        let url_ = this.baseUrl + "/plugins";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllPlugins(_response);
        });
    }

    protected processGetAllPlugins(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * Get a list of all default templates.
     * @return List of all default templates.
     */
    getAllDefaultTemplates(): Promise<DefaultTemplate[]> {
        let url_ = this.baseUrl + "/default-templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllDefaultTemplates(_response);
        });
    }

    protected processGetAllDefaultTemplates(response: Response): Promise<DefaultTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DefaultTemplate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefaultTemplate[]>(<any>null);
    }

    /**
     * Create Default Template
     * @return Default Template successfully created and can be found in the body of the response.
     */
    createDefaultTemplate(body: DefaultTemplateWithoutId): Promise<DefaultTemplate> {
        let url_ = this.baseUrl + "/default-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDefaultTemplate(_response);
        });
    }

    protected processCreateDefaultTemplate(response: Response): Promise<DefaultTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DefaultTemplate.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Unable to create Default Template due to existing name.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefaultTemplate>(<any>null);
    }

    /**
     * Delete Default Template
     * @param defaultTemplateId DefaultTemplateId to retrieve
     * @return Default Template deleted.
     */
    deleteDefaultTemplateById(defaultTemplateId: string): Promise<void> {
        let url_ = this.baseUrl + "/default-templates/{defaultTemplateId}";
        if (defaultTemplateId === undefined || defaultTemplateId === null)
            throw new Error("The parameter 'defaultTemplateId' must be defined.");
        url_ = url_.replace("{defaultTemplateId}", encodeURIComponent("" + defaultTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDefaultTemplateById(_response);
        });
    }

    protected processDeleteDefaultTemplateById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Unable to delete Default Template due to dependency.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get Default Template
     * @param defaultTemplateId DefaultTemplateId to retrieve
     * @return Default Template
     */
    getDefaultTemplateById(defaultTemplateId: string): Promise<DefaultTemplate> {
        let url_ = this.baseUrl + "/default-templates/{defaultTemplateId}";
        if (defaultTemplateId === undefined || defaultTemplateId === null)
            throw new Error("The parameter 'defaultTemplateId' must be defined.");
        url_ = url_.replace("{defaultTemplateId}", encodeURIComponent("" + defaultTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDefaultTemplateById(_response);
        });
    }

    protected processGetDefaultTemplateById(response: Response): Promise<DefaultTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Default Template not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefaultTemplate>(<any>null);
    }

    /**
     * Update Default Template
     * @param defaultTemplateId DefaultTemplateId to update
     * @return Default Template successfully updated and can be found in the body of the response.
     */
    updateDefaultTemplate(defaultTemplateId: string, body: DefaultTemplateWithoutId): Promise<DefaultTemplate> {
        let url_ = this.baseUrl + "/default-templates/{defaultTemplateId}";
        if (defaultTemplateId === undefined || defaultTemplateId === null)
            throw new Error("The parameter 'defaultTemplateId' must be defined.");
        url_ = url_.replace("{defaultTemplateId}", encodeURIComponent("" + defaultTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDefaultTemplate(_response);
        });
    }

    protected processUpdateDefaultTemplate(response: Response): Promise<DefaultTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefaultTemplate>(<any>null);
    }

    /**
     * Get a list of all implementations.
     * @return List of all Implementations.
     */
    getAllImplementations(pageNumber: number, pageSize: number): Promise<Implementation[]> {
        let url_ = this.baseUrl + "/implementations?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllImplementations(_response);
        });
    }

    protected processGetAllImplementations(response: Response): Promise<Implementation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Implementation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Implementation[]>(<any>null);
    }

    /**
     * Create Implementation
     * @return Implementation successfully created and can be found in the body of the response.
     */
    createImplementation(body: ImplementationWithoutId): Promise<Implementation> {
        let url_ = this.baseUrl + "/implementations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateImplementation(_response);
        });
    }

    protected processCreateImplementation(response: Response): Promise<Implementation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = Implementation.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Unable to create implementation due to existing name.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Implementation>(<any>null);
    }

    /**
     * Delete Implementation
     * @param implementationId ImplementationId to retrieve
     * @return Implementation deleted.
     */
    deleteImplementationById(implementationId: string): Promise<void> {
        let url_ = this.baseUrl + "/implementations/{implementationId}";
        if (implementationId === undefined || implementationId === null)
            throw new Error("The parameter 'implementationId' must be defined.");
        url_ = url_.replace("{implementationId}", encodeURIComponent("" + implementationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteImplementationById(_response);
        });
    }

    protected processDeleteImplementationById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Unable to delete implementation due to dependency.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get Implementation
     * @param implementationId ImplementationId to retrieve
     * @return Implementation
     */
    getImplementationById(implementationId: string): Promise<Implementation> {
        let url_ = this.baseUrl + "/implementations/{implementationId}";
        if (implementationId === undefined || implementationId === null)
            throw new Error("The parameter 'implementationId' must be defined.");
        url_ = url_.replace("{implementationId}", encodeURIComponent("" + implementationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetImplementationById(_response);
        });
    }

    protected processGetImplementationById(response: Response): Promise<Implementation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Implementation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Implementation not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Implementation>(<any>null);
    }

    /**
     * Update Implementation
     * @param implementationId ImplementationId to retrieve
     * @return Implementation successfully updated and can be found in the body of the response.
     */
    updateImplementation(implementationId: string, body: ImplementationWithoutId): Promise<Implementation> {
        let url_ = this.baseUrl + "/implementations/{implementationId}";
        if (implementationId === undefined || implementationId === null)
            throw new Error("The parameter 'implementationId' must be defined.");
        url_ = url_.replace("{implementationId}", encodeURIComponent("" + implementationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateImplementation(_response);
        });
    }

    protected processUpdateImplementation(response: Response): Promise<Implementation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Implementation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Implementation not found.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Unable to update implementation due to existing name.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Implementation>(<any>null);
    }

    /**
     * Get a list of all Event Templates
     * @param implementationId (optional) 
     * @return List of all matching Event Templates
     */
    getAllEventTemplates(implementationId: string | undefined, pageNumber: number, pageSize: number): Promise<EventTemplate[]> {
        let url_ = this.baseUrl + "/event-templates?";
        if (implementationId === null)
            throw new Error("The parameter 'implementationId' cannot be null.");
        else if (implementationId !== undefined)
            url_ += "implementationId=" + encodeURIComponent("" + implementationId) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllEventTemplates(_response);
        });
    }

    protected processGetAllEventTemplates(response: Response): Promise<EventTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventTemplate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventTemplate[]>(<any>null);
    }

    /**
     * Create Event Template
     * @return Event Template successfully created and can be found in the body of the response.
     */
    createEventTemplate(body: EventTemplateWithoutId): Promise<EventTemplate> {
        let url_ = this.baseUrl + "/event-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateEventTemplate(_response);
        });
    }

    protected processCreateEventTemplate(response: Response): Promise<EventTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = EventTemplate.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Template already exists for this learning event and implementation.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventTemplate>(<any>null);
    }

    /**
     * @param eventTemplateId EventTemplate to delete.
     * @return EventTemplate deleted.
     */
    deleteEventTemplateById(eventTemplateId: string): Promise<void> {
        let url_ = this.baseUrl + "/event-templates/{eventTemplateId}";
        if (eventTemplateId === undefined || eventTemplateId === null)
            throw new Error("The parameter 'eventTemplateId' must be defined.");
        url_ = url_.replace("{eventTemplateId}", encodeURIComponent("" + eventTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteEventTemplateById(_response);
        });
    }

    protected processDeleteEventTemplateById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Template is in use. Please delete any events using this template before attempting to delete.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param eventTemplateId EventTemplate to retrieve.
     * @return EventTemplate
     */
    getEventTemplateById(eventTemplateId: string): Promise<EventTemplate> {
        let url_ = this.baseUrl + "/event-templates/{eventTemplateId}";
        if (eventTemplateId === undefined || eventTemplateId === null)
            throw new Error("The parameter 'eventTemplateId' must be defined.");
        url_ = url_.replace("{eventTemplateId}", encodeURIComponent("" + eventTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventTemplateById(_response);
        });
    }

    protected processGetEventTemplateById(response: Response): Promise<EventTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventTemplate>(<any>null);
    }

    /**
     * Update Event Template
     * @param eventTemplateId EventTemplate to retrieve.
     * @return Event Template successfully updated and can be found in the body of the response.
     */
    updateEventTemplate(eventTemplateId: string, body: EventTemplateWithoutId): Promise<EventTemplate> {
        let url_ = this.baseUrl + "/event-templates/{eventTemplateId}";
        if (eventTemplateId === undefined || eventTemplateId === null)
            throw new Error("The parameter 'eventTemplateId' must be defined.");
        url_ = url_.replace("{eventTemplateId}", encodeURIComponent("" + eventTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateEventTemplate(_response);
        });
    }

    protected processUpdateEventTemplate(response: Response): Promise<EventTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Template already exists for this learning event and implementation.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventTemplate>(<any>null);
    }

    /**
     * Get a list of all Learning Events
     * @param contentMetadataId (optional) 
     * @return List of all matching Events
     */
    getAllLearningEvents(contentMetadataId: string | undefined, pageNumber: number, pageSize: number): Promise<LearningEvent[]> {
        let url_ = this.baseUrl + "/learning-events?";
        if (contentMetadataId === null)
            throw new Error("The parameter 'contentMetadataId' cannot be null.");
        else if (contentMetadataId !== undefined)
            url_ += "contentMetadataId=" + encodeURIComponent("" + contentMetadataId) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllLearningEvents(_response);
        });
    }

    protected processGetAllLearningEvents(response: Response): Promise<LearningEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LearningEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningEvent[]>(<any>null);
    }

    /**
     * Create Learning Event
     * @return Learning Event successfully created and can be found in the body of the response.
     */
    createLearningEvent(body: LearningEventWithoutId): Promise<LearningEvent> {
        let url_ = this.baseUrl + "/learning-events";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateLearningEvent(_response);
        });
    }

    protected processCreateLearningEvent(response: Response): Promise<LearningEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = LearningEvent.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Unable to create LearningEvent due to existing name.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningEvent>(<any>null);
    }

    /**
     * Delete LearningEvent
     * @param learningEventId LearningEventId to retrieve
     * @return LearningEvent deleted.
     */
    deleteLearningEventById(learningEventId: string): Promise<void> {
        let url_ = this.baseUrl + "/learning-events/{learningEventId}";
        if (learningEventId === undefined || learningEventId === null)
            throw new Error("The parameter 'learningEventId' must be defined.");
        url_ = url_.replace("{learningEventId}", encodeURIComponent("" + learningEventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteLearningEventById(_response);
        });
    }

    protected processDeleteLearningEventById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Unable to delete LearningEvent due to dependency.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get LearningEvent
     * @param learningEventId LearningEventId to retrieve
     * @return LearningEvent
     */
    getLearningEventById(learningEventId: string): Promise<LearningEvent> {
        let url_ = this.baseUrl + "/learning-events/{learningEventId}";
        if (learningEventId === undefined || learningEventId === null)
            throw new Error("The parameter 'learningEventId' must be defined.");
        url_ = url_.replace("{learningEventId}", encodeURIComponent("" + learningEventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLearningEventById(_response);
        });
    }

    protected processGetLearningEventById(response: Response): Promise<LearningEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LearningEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("LearningEvent not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningEvent>(<any>null);
    }

    /**
     * Update LearningEvent
     * @param learningEventId LearningEventId to retrieve
     * @return LearningEvent successfully updated and can be found in the body of the response.
     */
    updateLearningEvent(learningEventId: string, body: LearningEventWithoutId): Promise<LearningEvent> {
        let url_ = this.baseUrl + "/learning-events/{learningEventId}";
        if (learningEventId === undefined || learningEventId === null)
            throw new Error("The parameter 'learningEventId' must be defined.");
        url_ = url_.replace("{learningEventId}", encodeURIComponent("" + learningEventId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLearningEvent(_response);
        });
    }

    protected processUpdateLearningEvent(response: Response): Promise<LearningEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LearningEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("LearningEvent not found.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Unable to update LearningEvent due to existing name.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningEvent>(<any>null);
    }

    /**
     * Get a list of all Learning progress
     * @param contentMetadataId (optional) Content Metadata Id to which the progress belongs.
     * @param companyId (optional) Company Id to which the progress belongs.
     * @param userId (optional) User Id to which the progress belongs.
     * @return Learning Progress
     */
    getAllLearningProgress(contentMetadataId: string | undefined, companyId: string | undefined, userId: string | undefined, pageNumber: number, pageSize: number): Promise<LearningProgress[]> {
        let url_ = this.baseUrl + "/learning-progress?";
        if (contentMetadataId === null)
            throw new Error("The parameter 'contentMetadataId' cannot be null.");
        else if (contentMetadataId !== undefined)
            url_ += "contentMetadataId=" + encodeURIComponent("" + contentMetadataId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllLearningProgress(_response);
        });
    }

    protected processGetAllLearningProgress(response: Response): Promise<LearningProgress[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LearningProgress.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have sufficient permissions to perform this action.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningProgress[]>(<any>null);
    }

    /**
     * Submit a rating for an experience.
     * @param roomMetadataId RoomMetadataId to submit rating for.
     * @return Rating successfully submitted.
     */
    submitRating(roomMetadataId: string, body: Rating): Promise<void> {
        let url_ = this.baseUrl + "/rooms/{roomMetadataId}/ratings";
        if (roomMetadataId === undefined || roomMetadataId === null)
            throw new Error("The parameter 'roomMetadataId' must be defined.");
        url_ = url_.replace("{roomMetadataId}", encodeURIComponent("" + roomMetadataId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitRating(_response);
        });
    }

    protected processSubmitRating(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to submit a rating for this experience.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Room not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get TinCan SCORM Package.
     * @param roomMetadataId RoomMetadataId to retrieve SCORM package for.
     * @return The tincan configuration
     */
    getTinCanScormPackage(roomMetadataId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/rooms/{roomMetadataId}/tincan.zip";
        if (roomMetadataId === undefined || roomMetadataId === null)
            throw new Error("The parameter 'roomMetadataId' must be defined.");
        url_ = url_.replace("{roomMetadataId}", encodeURIComponent("" + roomMetadataId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTinCanScormPackage(_response);
        });
    }

    protected processGetTinCanScormPackage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to retrieve the tincan configuration for this learning object.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Room metadata not found.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            return throwException("Error when accessing blob storage", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Get rating metrics for company experiences.
     * @param companyId CompanyId to retrieve rating metrics for.
     * @return List of rating metrics for the company.
     */
    getCompanyRatings(companyId: string, body: MetricFilter): Promise<RatingMetricResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/metrics/ratings";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyRatings(_response);
        });
    }

    protected processGetCompanyRatings(response: Response): Promise<RatingMetricResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RatingMetricResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to view ratings for this company.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Company not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RatingMetricResult>(<any>null);
    }

    /**
     * Get external rating metrics for company experiences.
     * @param companyId CompanyId to retrieve rating metrics for.
     * @return List of rating metrics for the company.
     */
    getExternalCompanyRatings(companyId: string, body: ExternalMetricFilter): Promise<ExternalRatingMetricResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/external-metrics/ratings";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExternalCompanyRatings(_response);
        });
    }

    protected processGetExternalCompanyRatings(response: Response): Promise<ExternalRatingMetricResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalRatingMetricResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("You must be authenticated.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You do not have permission to view ratings for this company.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Company not found.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalRatingMetricResult>(<any>null);
    }
}

export class DefaultTemplateWithoutId implements IDefaultTemplateWithoutId {
    plugin!: string;
    templateData?: string;

    constructor(data?: IDefaultTemplateWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plugin = _data["Plugin"];
            this.templateData = _data["TemplateData"];
        }
    }

    static fromJS(data: any): DefaultTemplateWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultTemplateWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Plugin"] = this.plugin;
        data["TemplateData"] = this.templateData;
        return data;
    }
}

export interface IDefaultTemplateWithoutId {
    plugin: string;
    templateData?: string;
}

export class DefaultTemplate extends DefaultTemplateWithoutId implements IDefaultTemplate {
    defaultTemplateId!: string;

    constructor(data?: IDefaultTemplate) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.defaultTemplateId = _data["DefaultTemplateId"];
        }
    }

    static fromJS(data: any): DefaultTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DefaultTemplateId"] = this.defaultTemplateId;
        super.toJSON(data);
        return data;
    }
}

export interface IDefaultTemplate extends IDefaultTemplateWithoutId {
    defaultTemplateId: string;
}

export class ImplementationWithoutId implements IImplementationWithoutId {
    implementationName!: string;
    plugin!: string;
    companyId!: string;
    defaultTemplate?: string;

    constructor(data?: IImplementationWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.implementationName = _data["ImplementationName"];
            this.plugin = _data["Plugin"];
            this.companyId = _data["CompanyId"];
            this.defaultTemplate = _data["DefaultTemplate"];
        }
    }

    static fromJS(data: any): ImplementationWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new ImplementationWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ImplementationName"] = this.implementationName;
        data["Plugin"] = this.plugin;
        data["CompanyId"] = this.companyId;
        data["DefaultTemplate"] = this.defaultTemplate;
        return data;
    }
}

export interface IImplementationWithoutId {
    implementationName: string;
    plugin: string;
    companyId: string;
    defaultTemplate?: string;
}

export class Implementation extends ImplementationWithoutId implements IImplementation {
    implementationId!: string;

    constructor(data?: IImplementation) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.implementationId = _data["ImplementationId"];
        }
    }

    static fromJS(data: any): Implementation {
        data = typeof data === 'object' ? data : {};
        let result = new Implementation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ImplementationId"] = this.implementationId;
        super.toJSON(data);
        return data;
    }
}

export interface IImplementation extends IImplementationWithoutId {
    implementationId: string;
}

export class LearningEventWithoutId implements ILearningEventWithoutId {
    contentMetadataId!: string;
    learningEventName!: string;

    constructor(data?: ILearningEventWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentMetadataId = _data["ContentMetadataId"];
            this.learningEventName = _data["LearningEventName"];
        }
    }

    static fromJS(data: any): LearningEventWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new LearningEventWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContentMetadataId"] = this.contentMetadataId;
        data["LearningEventName"] = this.learningEventName;
        return data;
    }
}

export interface ILearningEventWithoutId {
    contentMetadataId: string;
    learningEventName: string;
}

export class LearningEvent extends LearningEventWithoutId implements ILearningEvent {
    learningEventId!: string;

    constructor(data?: ILearningEvent) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.learningEventId = _data["LearningEventId"];
        }
    }

    static fromJS(data: any): LearningEvent {
        data = typeof data === 'object' ? data : {};
        let result = new LearningEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LearningEventId"] = this.learningEventId;
        super.toJSON(data);
        return data;
    }
}

export interface ILearningEvent extends ILearningEventWithoutId {
    learningEventId: string;
}

export class LearningProgressWithoutId implements ILearningProgressWithoutId {
    learningEventId!: string;
    userId!: string;
    multiplayerSessionId?: string;
    templateValues?: { [key: string]: string; };

    constructor(data?: ILearningProgressWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.learningEventId = _data["LearningEventId"];
            this.userId = _data["UserId"];
            this.multiplayerSessionId = _data["MultiplayerSessionId"];
            if (_data["TemplateValues"]) {
                this.templateValues = {} as any;
                for (let key in _data["TemplateValues"]) {
                    if (_data["TemplateValues"].hasOwnProperty(key))
                        (<any>this.templateValues)![key] = _data["TemplateValues"][key];
                }
            }
        }
    }

    static fromJS(data: any): LearningProgressWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new LearningProgressWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LearningEventId"] = this.learningEventId;
        data["UserId"] = this.userId;
        data["MultiplayerSessionId"] = this.multiplayerSessionId;
        if (this.templateValues) {
            data["TemplateValues"] = {};
            for (let key in this.templateValues) {
                if (this.templateValues.hasOwnProperty(key))
                    (<any>data["TemplateValues"])[key] = this.templateValues[key];
            }
        }
        return data;
    }
}

export interface ILearningProgressWithoutId {
    learningEventId: string;
    userId: string;
    multiplayerSessionId?: string;
    templateValues?: { [key: string]: string; };
}

export class LearningProgress extends LearningProgressWithoutId implements ILearningProgress {
    learningProgressId!: string;

    constructor(data?: ILearningProgress) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.learningProgressId = _data["LearningProgressId"];
        }
    }

    static fromJS(data: any): LearningProgress {
        data = typeof data === 'object' ? data : {};
        let result = new LearningProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LearningProgressId"] = this.learningProgressId;
        super.toJSON(data);
        return data;
    }
}

export interface ILearningProgress extends ILearningProgressWithoutId {
    learningProgressId: string;
}

export class EventTemplateWithoutId implements IEventTemplateWithoutId {
    implementationId!: string;
    learningEventId!: string;
    template?: string;

    constructor(data?: IEventTemplateWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.implementationId = _data["ImplementationId"];
            this.learningEventId = _data["LearningEventId"];
            this.template = _data["Template"];
        }
    }

    static fromJS(data: any): EventTemplateWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new EventTemplateWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ImplementationId"] = this.implementationId;
        data["LearningEventId"] = this.learningEventId;
        data["Template"] = this.template;
        return data;
    }
}

export interface IEventTemplateWithoutId {
    implementationId: string;
    learningEventId: string;
    template?: string;
}

export class EventTemplate extends EventTemplateWithoutId implements IEventTemplate {
    eventTemplateId!: string;

    constructor(data?: IEventTemplate) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.eventTemplateId = _data["EventTemplateId"];
        }
    }

    static fromJS(data: any): EventTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new EventTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EventTemplateId"] = this.eventTemplateId;
        super.toJSON(data);
        return data;
    }
}

export interface IEventTemplate extends IEventTemplateWithoutId {
    eventTemplateId: string;
}

export class Rating implements IRating {
    value!: number;
    moduleId!: string;
    ratingType!: RatingType;
    maxValue!: number;
    moduleName?: string;
    comments?: string;

    constructor(data?: IRating) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["Value"];
            this.moduleId = _data["ModuleId"];
            this.ratingType = _data["RatingType"];
            this.maxValue = _data["MaxValue"];
            this.moduleName = _data["ModuleName"];
            this.comments = _data["Comments"];
        }
    }

    static fromJS(data: any): Rating {
        data = typeof data === 'object' ? data : {};
        let result = new Rating();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Value"] = this.value;
        data["ModuleId"] = this.moduleId;
        data["RatingType"] = this.ratingType;
        data["MaxValue"] = this.maxValue;
        data["ModuleName"] = this.moduleName;
        data["Comments"] = this.comments;
        return data;
    }
}

export interface IRating {
    value: number;
    moduleId: string;
    ratingType: RatingType;
    maxValue: number;
    moduleName?: string;
    comments?: string;
}

export enum RatingType {
    Practice = "Practice",
    Assessment = "Assessment",
}

export class RatingTypeValue implements IRatingTypeValue {
    ratingType!: RatingType;
    value!: number;
    count!: number;

    constructor(data?: IRatingTypeValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ratingType = _data["RatingType"];
            this.value = _data["Value"];
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): RatingTypeValue {
        data = typeof data === 'object' ? data : {};
        let result = new RatingTypeValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RatingType"] = this.ratingType;
        data["Value"] = this.value;
        data["Count"] = this.count;
        return data;
    }
}

export interface IRatingTypeValue {
    ratingType: RatingType;
    value: number;
    count: number;
}

export class MetricFilter implements IMetricFilter {
    startDate!: Date;
    endDate!: Date;
    contentMetadataIds?: string[];
    countries?: string[];

    constructor(data?: IMetricFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["ContentMetadataIds"])) {
                this.contentMetadataIds = [] as any;
                for (let item of _data["ContentMetadataIds"])
                    this.contentMetadataIds!.push(item);
            }
            if (Array.isArray(_data["Countries"])) {
                this.countries = [] as any;
                for (let item of _data["Countries"])
                    this.countries!.push(item);
            }
        }
    }

    static fromJS(data: any): MetricFilter {
        data = typeof data === 'object' ? data : {};
        let result = new MetricFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.contentMetadataIds)) {
            data["ContentMetadataIds"] = [];
            for (let item of this.contentMetadataIds)
                data["ContentMetadataIds"].push(item);
        }
        if (Array.isArray(this.countries)) {
            data["Countries"] = [];
            for (let item of this.countries)
                data["Countries"].push(item);
        }
        return data;
    }
}

export interface IMetricFilter {
    startDate: Date;
    endDate: Date;
    contentMetadataIds?: string[];
    countries?: string[];
}

export class ExternalMetricFilter implements IExternalMetricFilter {
    startDate!: Date;
    endDate!: Date;
    licenseIds!: string[];

    constructor(data?: IExternalMetricFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.licenseIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["LicenseIds"])) {
                this.licenseIds = [] as any;
                for (let item of _data["LicenseIds"])
                    this.licenseIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalMetricFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalMetricFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.licenseIds)) {
            data["LicenseIds"] = [];
            for (let item of this.licenseIds)
                data["LicenseIds"].push(item);
        }
        return data;
    }
}

export interface IExternalMetricFilter {
    startDate: Date;
    endDate: Date;
    licenseIds: string[];
}

export enum Dimension {
    Week = "Week",
    Month = "Month",
    Quarter = "Quarter",
    Year = "Year",
}

export class RatingMetric implements IRatingMetric {
    value!: number;
    moduleId!: string;
    ratingType!: RatingType;
    maxValue!: number;
    moduleName?: string;
    comments?: string;

    constructor(data?: IRatingMetric) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["Value"];
            this.moduleId = _data["ModuleId"];
            this.ratingType = _data["RatingType"];
            this.maxValue = _data["MaxValue"];
            this.moduleName = _data["ModuleName"];
            this.comments = _data["Comments"];
        }
    }

    static fromJS(data: any): RatingMetric {
        data = typeof data === 'object' ? data : {};
        let result = new RatingMetric();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Value"] = this.value;
        data["ModuleId"] = this.moduleId;
        data["RatingType"] = this.ratingType;
        data["MaxValue"] = this.maxValue;
        data["ModuleName"] = this.moduleName;
        data["Comments"] = this.comments;
        return data;
    }
}

export interface IRatingMetric {
    value: number;
    moduleId: string;
    ratingType: RatingType;
    maxValue: number;
    moduleName?: string;
    comments?: string;
}

export class RatingExperienceDataPoint implements IRatingExperienceDataPoint {
    contentMetadataFriendlyName!: string;
    contentMetadataId!: string;
    values!: RatingTypeValue[];

    constructor(data?: IRatingExperienceDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.values = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentMetadataFriendlyName = _data["ContentMetadataFriendlyName"];
            this.contentMetadataId = _data["ContentMetadataId"];
            if (Array.isArray(_data["Values"])) {
                this.values = [] as any;
                for (let item of _data["Values"])
                    this.values!.push(RatingTypeValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RatingExperienceDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new RatingExperienceDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContentMetadataFriendlyName"] = this.contentMetadataFriendlyName;
        data["ContentMetadataId"] = this.contentMetadataId;
        if (Array.isArray(this.values)) {
            data["Values"] = [];
            for (let item of this.values)
                data["Values"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRatingExperienceDataPoint {
    contentMetadataFriendlyName: string;
    contentMetadataId: string;
    values: RatingTypeValue[];
}

export class ExternalRatingExperienceDataPoint implements IExternalRatingExperienceDataPoint {
    licenseId!: string;
    values!: RatingTypeValue[];

    constructor(data?: IExternalRatingExperienceDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.values = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseId = _data["LicenseId"];
            if (Array.isArray(_data["Values"])) {
                this.values = [] as any;
                for (let item of _data["Values"])
                    this.values!.push(RatingTypeValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalRatingExperienceDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalRatingExperienceDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LicenseId"] = this.licenseId;
        if (Array.isArray(this.values)) {
            data["Values"] = [];
            for (let item of this.values)
                data["Values"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExternalRatingExperienceDataPoint {
    licenseId: string;
    values: RatingTypeValue[];
}

export class RatingMetricResult implements IRatingMetricResult {
    dataPoints!: RatingExperienceDataPoint[];
    aggregateValues!: RatingTypeValue[];

    constructor(data?: IRatingMetricResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataPoints = [];
            this.aggregateValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["DataPoints"])) {
                this.dataPoints = [] as any;
                for (let item of _data["DataPoints"])
                    this.dataPoints!.push(RatingExperienceDataPoint.fromJS(item));
            }
            if (Array.isArray(_data["AggregateValues"])) {
                this.aggregateValues = [] as any;
                for (let item of _data["AggregateValues"])
                    this.aggregateValues!.push(RatingTypeValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RatingMetricResult {
        data = typeof data === 'object' ? data : {};
        let result = new RatingMetricResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataPoints)) {
            data["DataPoints"] = [];
            for (let item of this.dataPoints)
                data["DataPoints"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateValues)) {
            data["AggregateValues"] = [];
            for (let item of this.aggregateValues)
                data["AggregateValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRatingMetricResult {
    dataPoints: RatingExperienceDataPoint[];
    aggregateValues: RatingTypeValue[];
}

export class ExternalRatingMetricResult implements IExternalRatingMetricResult {
    dataPoints!: ExternalRatingExperienceDataPoint[];
    aggregateValues!: RatingTypeValue[];

    constructor(data?: IExternalRatingMetricResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataPoints = [];
            this.aggregateValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["DataPoints"])) {
                this.dataPoints = [] as any;
                for (let item of _data["DataPoints"])
                    this.dataPoints!.push(ExternalRatingExperienceDataPoint.fromJS(item));
            }
            if (Array.isArray(_data["AggregateValues"])) {
                this.aggregateValues = [] as any;
                for (let item of _data["AggregateValues"])
                    this.aggregateValues!.push(RatingTypeValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalRatingMetricResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalRatingMetricResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataPoints)) {
            data["DataPoints"] = [];
            for (let item of this.dataPoints)
                data["DataPoints"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregateValues)) {
            data["AggregateValues"] = [];
            for (let item of this.aggregateValues)
                data["AggregateValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExternalRatingMetricResult {
    dataPoints: ExternalRatingExperienceDataPoint[];
    aggregateValues: RatingTypeValue[];
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/* tslint:disable */
/* eslint-disable */